import React from 'react'
import { CFView, CFImage, DefaultScreen, MobileScreen } from 'components'
import { mobilePromotion1, mobilePromotion2, mobilePromotion3, promotions1, promotions2, promotions3 } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView column center>
          <CFImage src={mobilePromotion1} w="100%" alt="Promotions" />
          <CFImage src={mobilePromotion2} w="100%" alt="Promotions" />
          <CFImage src={mobilePromotion3} w="100%" alt="Promotions" />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView column center m="0 auto" maxWidth="1400px">
          <CFImage src={promotions1} w="100%" alt="Promotions" />
          <CFImage src={promotions3} w="100%" alt="Promotions" />
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
